var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./LicensurePlans.scss";
import { WmButton, WmSnackbar, WmActionMenu, WmMenuitem, WmModal, WmModalHeader, WmModalFooter, } from "@watermarkinsights/ripple-react";
import { timelineSelector, getTimeline, getPrograms, resetTimelineState, setEditTimeline, openDeleteReqModal, openInformationReqModal, deleteRequirement, closeSnackbar, setRequirementValidation, resetNewRequirementFiles, placeReqToNewPosition, updateRequirementsBulk, validateTimelineTitle, updateTimeline, resetIsCopyCompleted, placeReqToNewPositionKeyboard, commitCacheTimelineData, setBlockMovement, setAriaMoveText, setCacheTimelineData, resetIsFetchingCurrentProgram, getRequirementDetails, } from "./TimelineSlice";
import { useSelector, useDispatch } from "react-redux";
import EditTimeline from "./EditTimeline";
import Requirements from "./Requirements";
import { useEffect, useState, useRef } from "react";
import { focusButtonComponent, closeFlyout, focusActionMenuComponent, navigateToElement, } from "../../static/js/commons.js";
import DeleteModal from "../common/component/DeleteWmModal";
import translate from "../../i18n/translate";
import InformationModal from "../../features/common/component/InformationWmModal";
import DraggableItem from "../../features/common/component/DraggableItem";
import DraggableArea from "../../features/common/component/DraggableArea";
import ViewDetails from "./ViewDetails";
import { useIntl } from "react-intl";
import { getLoggedInUserInfo, userSelector, } from "../../features/login/UserSlice";
import DropZone from "../../features/common/component/DropZone";
import InputField from "../common/component/InputField";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Constants from "../common/constants/applicationConstants.json";
import SelectApplication from "./SelectApplication";
import { applicationSelector, getApplication, resetApplicationObj, } from "../../features/programApplications/ApplicationSlice";
import SelectRequirementType from "./SelectRequirementType";
import TimeLogRequirements from "./TimeLogRequirements";
export const initialRequirementState = {
    anyFileSubmitted: false,
    reviewed: false,
    isStudentFileUploadRequired: false,
    description: "",
    sectionUuid: null,
    subSectionUuid: null,
    timelineUuid: "",
    title: "",
    uuid: "",
    referenceLinksList: [],
    files: [],
    sortOrder: 1,
    studentFileUploaded: false,
    acknowledgementSelected: false,
    applicationUuid: "",
    requirementType: "",
    anySubmissionExist: false,
    dueDate: "",
    requirementConfirmationCheckboxes: [],
    threshold: 0,
    logCategory: {},
    courses: [],
};
export default function ViewTimeline(props) {
    var _a;
    const { timelineData, currentProgramData, showEditableTimeline, displayDeleteReqModal, currentTimelineUuid, currentRequirementUuid, snackNotifications, deleteReqType, deletedReqIndex, currentSectionUuid, currentSubSectionUuid, timelineTitleValid, cacheTimelineData, blockMovement, ariaMoveText, currentRequirementType, isCopyCompleted, isFetchingTimeline, } = useSelector(timelineSelector);
    const { userInfo } = useSelector(userSelector);
    const location = useLocation();
    const specialCharPattern = /[#?:"*<>|.\/\\']/;
    const timelineSections = cacheTimelineData.sections;
    document.title = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.programTitle) + " | Watermark";
    let [detailView, showDetailView] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let [addRequirementPage, setAddRequirementPage] = useState(false);
    let [addTimeLogPage, setAddTimeLogPage] = useState(false);
    let [requirementId, setRequirementId] = useState("");
    let [sectionType, setSectionType] = useState("");
    let [currentRequirement, setCurrentRequirement] = useState(initialRequirementState);
    let [openDeleteRequestModal, setOpenDeleteRequestModal] = useState(false);
    let [openEditWarningRequestModal, setopenEditWarningRequestModal] = useState(false);
    const [openEditTitleModal, setOpenEditTitleModal] = useState(false);
    const [enableLiveRegion, setEnableLiveRegion] = useState(false);
    const [isTitleValid, setIsTitleValid] = useState(true);
    const [focusId, setFocusId] = useState("");
    const [category, setCategory] = useState("");
    const [liveAriaObject, setLiveAriaObject] = useState({});
    let [selectApplication, setSelectApplication] = useState(false);
    const { applicationObj } = useSelector(applicationSelector);
    let [editMode, setEditMode] = useState();
    const [selectedApplications, setSelectedApplications] = useState([]);
    const [selectRequirementType, setSelectRequirementType] = useState(false);
    const [requirementType, setRequirementType] = useState("stdReq");
    const [requirementTypeOrder, setRequirementTypeOrder] = useState({
        reqId: "",
        sectionType: "",
        sortOrder: 0,
    });
    const [getDetailsFlag, setGetDetailsFlag] = useState(false);
    const [titleSpecialCharError, setTitleSpecialCharError] = useState(false);
    const customErrorMessage = useIntl().formatMessage({
        id: "app.global.special.custom.error.message",
    }, { field: "Plan" });
    const closeTimelineHandler = (event) => __awaiter(this, void 0, void 0, function* () {
        var _b, _c;
        event.preventDefault();
        if (location.search === "?create") {
            dispatch(resetTimelineState({}));
        }
        yield Promise.all([dispatch(resetIsFetchingCurrentProgram({}))]);
        navigate({
            pathname: "/licensurePlans/programs/" + programUuid,
        }, {
            state: {
                focusButtonEl: true,
                programTitle: (_b = location.state) === null || _b === void 0 ? void 0 : _b.programTitle,
                currentTab: "item-2",
                listingPageFilters: (_c = location.state) === null || _c === void 0 ? void 0 : _c.listingPageFilters,
                previousPage: location.search,
            },
        });
        if (location.search === "?create" || "?edit") {
            setTimeout(() => focusButtonComponent(timelineData.title), 1000);
        }
    });
    const editTimelineHandler = (event) => {
        event.preventDefault();
        dispatch(setEditTimeline(true));
    };
    const { timelineUuid, programUuid } = useParams();
    useEffect(() => {
        if (!userInfo.gatewaysUser) {
            dispatch(getLoggedInUserInfo());
        }
        let orgUuid = localStorage.getItem("orgUuid");
        dispatch(getTimeline(timelineUuid)).then(() => setGetDetailsFlag(true));
        dispatch(getPrograms({ orgUuid, programUuid }));
        dispatch(resetIsCopyCompleted({}));
    }, []);
    useEffect(() => {
        return () => {
            if (!showEditableTimeline) {
                closeFlyout();
                showDetailView(false);
            }
        };
    }, [showEditableTimeline]);
    useEffect(() => {
        var _a;
        if (getDetailsFlag) {
            let allRequirementUuids = [];
            (_a = timelineData === null || timelineData === void 0 ? void 0 : timelineData.sections) === null || _a === void 0 ? void 0 : _a.forEach((sec) => {
                var _a, _b;
                (_a = sec.requirements) === null || _a === void 0 ? void 0 : _a.forEach((r) => {
                    allRequirementUuids.push(r.uuid);
                });
                (_b = sec === null || sec === void 0 ? void 0 : sec.subSections) === null || _b === void 0 ? void 0 : _b.forEach((subSec) => {
                    var _a;
                    (_a = subSec === null || subSec === void 0 ? void 0 : subSec.requirements) === null || _a === void 0 ? void 0 : _a.forEach((r) => {
                        allRequirementUuids.push(r.uuid);
                    });
                });
            });
            if (allRequirementUuids.length) {
                dispatch(getRequirementDetails({ requirementUuids: allRequirementUuids }));
            }
        }
    }, [getDetailsFlag]);
    useEffect(() => {
        if (detailView) {
            focusButtonComponent("view-details-close-btn");
        }
        else {
            focusButtonComponent("view-detail-" + currentRequirement.uuid);
        }
    }, [detailView]);
    const resetCurrentReq = () => {
        setCurrentRequirement(initialRequirementState);
        closeFlyout();
        setTimeout(() => focusActionMenuComponent("requirement-options-" +
            requirementId.substring(17, requirementId.length)), 100);
    };
    useEffect(() => {
        if (!addRequirementPage) {
            resetCurrentReq();
        }
    }, [addRequirementPage]);
    useEffect(() => {
        if (!addTimeLogPage) {
            resetCurrentReq();
        }
    }, [addTimeLogPage]);
    useEffect(() => {
        if (!selectApplication) {
            resetCurrentReq();
        }
    }, [selectApplication]);
    const handleFocusForRequirement = (currentDataArray, currentUuid) => {
        if ((currentDataArray === null || currentDataArray === void 0 ? void 0 : currentDataArray.requirements.length) === 0) {
            focusButtonComponent("add-requirement-button-" + currentUuid);
        }
        else {
            if ((currentDataArray === null || currentDataArray === void 0 ? void 0 : currentDataArray.requirements.length) === 1) {
                focusActionMenuComponent("requirement-options-" + currentDataArray.requirements[0].uuid);
            }
            else {
                if ((currentDataArray === null || currentDataArray === void 0 ? void 0 : currentDataArray.requirements.length) === deletedReqIndex) {
                    focusActionMenuComponent("requirement-options-" +
                        currentDataArray.requirements[deletedReqIndex - 1].uuid);
                }
                else {
                    focusActionMenuComponent("requirement-options-" +
                        (currentDataArray === null || currentDataArray === void 0 ? void 0 : currentDataArray.requirements[deletedReqIndex].uuid));
                }
            }
        }
    };
    useEffect(() => {
        if (!displayDeleteReqModal && deletedReqIndex != -1) {
            const section = timelineData.sections.find((section) => section.uuid === currentSectionUuid);
            if (deleteReqType == "section") {
                handleFocusForRequirement(section, currentSectionUuid);
            }
            else if (deleteReqType == "sub-section") {
                const subSection = section === null || section === void 0 ? void 0 : section.subSections.find((subSec) => subSec.uuid === currentSubSectionUuid);
                handleFocusForRequirement(subSection, currentSubSectionUuid);
            }
        }
    }, [displayDeleteReqModal]);
    const addRequirementHandler = () => {
        let req = Object.assign(Object.assign({}, initialRequirementState), { sortOrder: requirementTypeOrder.sortOrder });
        setCurrentRequirement(req);
        showDetailView(false);
        setRequirementId(requirementTypeOrder.reqId);
        setAddRequirementPage(true);
        setSectionType(requirementTypeOrder.sectionType);
        setFocusId(requirementTypeOrder.reqId);
    };
    const addAppHandler = () => {
        let req = Object.assign(Object.assign({}, initialRequirementState), { sortOrder: requirementTypeOrder.sortOrder });
        setSelectApplication(true);
        setEditMode(false);
        dispatch(resetApplicationObj());
        setCurrentRequirement(req);
        showDetailView(false);
        setRequirementId(requirementTypeOrder.reqId);
        setSectionType(requirementTypeOrder.sectionType);
        setFocusId(requirementTypeOrder.reqId);
    };
    const addTimeLogHandler = () => {
        let req = Object.assign(Object.assign({}, initialRequirementState), { sortOrder: requirementTypeOrder.sortOrder });
        setCurrentRequirement(req);
        showDetailView(false);
        setRequirementId(requirementTypeOrder.reqId);
        setAddTimeLogPage(true);
        setSectionType(requirementTypeOrder.sectionType);
        setFocusId(requirementTypeOrder.reqId);
    };
    let reqModalHeading = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.req.modalHeading",
    });
    let reqModalContent = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.req.modalContent",
    });
    let reqModalAriaLabel = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.req.ariaLabelValue",
    });
    let appModalHeading = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.app.modalHeading",
    });
    let appModalContent = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.app.modalContent",
    });
    let appModalAriaLabel = useIntl().formatMessage({
        id: "app.viewTimeline.delete.modal.app.ariaLabelValue",
    });
    const renderDeleteSectionModal = (isOpen, type) => {
        let modalHeading = reqModalHeading;
        let modalContent = reqModalContent;
        let ariaLabelValue = reqModalAriaLabel;
        if (type === "APPLICATION") {
            modalHeading = appModalHeading;
            modalContent = appModalContent;
            ariaLabelValue = appModalAriaLabel;
        }
        return (_jsx(DeleteModal, { isOpen: isOpen, onPrimaryClick: (event) => {
                deleteRequirementHandler(event, currentTimelineUuid, currentRequirementUuid);
                showDetailView(false);
            }, onSecondaryClick: closeDeleteModalHandler, modalContent: modalContent, modalHeading: modalHeading, ariaLabelValue: ariaLabelValue, modalId: "delete-modal", contentId: "content-delete-modal" }));
    };
    const renderInformationModal = (isOpen) => {
        let modalHeading = "Requirement can not be edited";
        let modalContent = "This Requirement can not be edited because it has received submissions from students in its associated cohorts.";
        let ariaLabelValue = "Delete Requirement";
        return (_jsx(InformationModal, { isOpen: isOpen, onPrimaryClick: (event) => {
                editRequirementHandler(event, currentTimelineUuid, currentRequirementUuid);
            }, 
            // onSecondaryClick={closeInformationModal}
            modalContent: modalContent, modalHeading: modalHeading, ariaLabelValue: ariaLabelValue, modalId: "information-modal", contentId: "content-information-modal" }));
    };
    const deleteRequirementHandler = (event, timelineUuid, id) => {
        event.preventDefault();
        setOpenDeleteRequestModal(false);
        dispatch(deleteRequirement({ timelineUuid, id }));
    };
    const editRequirementHandler = (event, timelineUuid, id) => {
        event.preventDefault();
        setopenEditWarningRequestModal(false);
    };
    const openDeleteModal = (event, title, currentTimelineUuid, currentSectionUuid, currentSubSectionUuid, currentRequirementUuid, requirementType) => {
        event.preventDefault();
        setOpenDeleteRequestModal(true);
        dispatch(openDeleteReqModal({
            displayDeleteReqModal: true,
            title,
            currentTimelineUuid,
            currentSectionUuid,
            currentSubSectionUuid,
            currentRequirementUuid,
            requirementType,
        }));
    };
    const openInformationModal = (event) => {
        event.preventDefault();
        setopenEditWarningRequestModal(true);
        dispatch(openInformationReqModal({
            displayEditReqModal: true,
        }));
    };
    const closeDeleteModalHandler = (event) => {
        event.preventDefault();
        setOpenDeleteRequestModal(false);
        dispatch(openDeleteReqModal({
            displayDeleteReqModal: false,
            title: "",
            currentTimelineUuid: "",
            currentSectionUuid: "",
            currentSubSectionUuid: "",
            currentRequirementUuid: "",
        }));
        focusActionMenuComponent("requirement-options-" + currentRequirementUuid);
    };
    const finishedSnackHandler = (event) => {
        event.preventDefault();
        dispatch(closeSnackbar(event.detail.id));
    };
    const renderDetailView = (event, requirement) => {
        event.preventDefault();
        setCurrentRequirement({
            anyFileSubmitted: requirement.anyFileSubmitted,
            reviewed: requirement.reviewed,
            isStudentFileUploadRequired: requirement.isStudentFileUploadRequired,
            referenceLinksList: requirement.referenceLinksList,
            description: requirement.description,
            sectionUuid: requirement.sectionUuid,
            subSectionUuid: requirement.subSectionUuid,
            timelineUuid: requirement.timelineUuid,
            title: requirement.title,
            uuid: requirement.uuid,
            files: requirement.files,
            sortOrder: requirement.sortOrder,
            studentFileUploaded: requirement.studentFileUploaded,
            acknowledgementSelected: requirement.acknowledgementSelected,
            requirementType: requirement.requirementType,
            applicationUuid: requirement.applicationUuid,
            anySubmissionExist: requirement.anySubmissionExist,
            dueDate: requirement.dueDate,
            requirementConfirmationCheckboxes: requirement.requirementConfirmationCheckboxes,
            threshold: requirement.threshold,
            logCategory: requirement.logCategory,
            courses: requirement.courses,
        });
        showDetailView(true);
    };
    const removeDetailView = () => {
        showDetailView(false);
        focusButtonComponent("view-detail-" + currentRequirement.uuid);
        closeFlyout();
    };
    const editTitleHandler = (event, title) => {
        setEnteredPlanTitle(timelineData.title);
        setOpenEditTitleModal(true);
    };
    const editClickHandler = (event, requirement, reqId, sectionType) => {
        setCurrentRequirement({
            anyFileSubmitted: requirement.anyFileSubmitted,
            reviewed: requirement.reviewed,
            isStudentFileUploadRequired: requirement.isStudentFileUploadRequired,
            referenceLinksList: requirement.referenceLinksList,
            description: requirement.description,
            sectionUuid: requirement.sectionUuid,
            subSectionUuid: requirement.subSectionUuid,
            timelineUuid: requirement.timelineUuid,
            title: requirement.title,
            uuid: requirement.uuid,
            files: requirement.files,
            sortOrder: requirement.sortOrder,
            studentFileUploaded: requirement.studentFileUploaded,
            acknowledgementSelected: requirement.acknowledgementSelected,
            requirementType: requirement.requirementType,
            applicationUuid: requirement.applicationUuid,
            anySubmissionExist: requirement.anySubmissionExist,
            dueDate: requirement.dueDate,
            requirementConfirmationCheckboxes: requirement.requirementConfirmationCheckboxes,
            threshold: requirement.threshold,
            logCategory: requirement.logCategory,
            courses: requirement.courses,
        });
        setRequirementId(reqId);
        showDetailView(false);
        setSectionType(sectionType);
        if (requirement.requirementType == "REQUIREMENT") {
            dispatch(resetNewRequirementFiles(requirement.files));
            setAddTimeLogPage(false);
            setAddRequirementPage(true);
            dispatch(setRequirementValidation(false));
        }
        else {
            setAddRequirementPage(false);
            setAddTimeLogPage(true);
        }
    };
    const requirementSpecifications = (req) => {
        var _a;
        return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: "textfieldlabel" }, { children: translate("global.condition") })), _jsxs("ul", Object.assign({ className: "list-conditions" }, { children: [_jsx("li", { children: req.isStudentFileUploadRequired
                                ? translate("global.studentFileUploadRequired")
                                : translate("global.studentFileUploadNotRequired") }, 1), _jsx("li", { children: ((_a = req.requirementConfirmationCheckboxes) === null || _a === void 0 ? void 0 : _a.length) > 0
                                ? translate("global.includeStudentSideAcknowledgement")
                                : translate("global.noStudentSideAcknowledgement") }, 2)] }))] }));
    };
    const moveText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.moveText",
    });
    const grabText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.grabText",
    });
    const dropText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.dropText",
    });
    const movedToPosition = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.movedToPosition",
    });
    const grabInfoText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.grabInfoText",
    });
    const requirementText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.requirementText",
    });
    const elementReleased = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.elementReleased",
    });
    const renderLiveRegion = () => {
        if (enableLiveRegion) {
            if (isElementReoderUsingKeyboard && liveAriaObject.keyCode === 13) {
                dispatch(setAriaMoveText({
                    text: `${requirementText} ${liveAriaObject.requirement.title} of type ${liveAriaObject.requirement.requirementType} ${grabText} ${grabInfoText}`,
                }));
            }
            else if (!isElementReoderUsingKeyboard) {
                if (liveAriaObject.keyCode === 27) {
                    dispatch(setAriaMoveText({ text: elementReleased }));
                }
                else if (liveAriaObject.keyCode === 13) {
                    dispatch(setAriaMoveText({
                        text: `${requirementText} ${liveAriaObject.requirement.title} of type ${liveAriaObject.requirement.requirementType} ${dropText}`,
                    }));
                }
            }
        }
        return (_jsx("div", Object.assign({ className: "sr-only", "aria-live": "polite", "aria-atomic": "true" }, { children: ariaMoveText })));
    };
    const [draggedItem, setDraggedItem] = useState("");
    const [draggedEnterItem, setDraggedEnterItem] = useState("");
    const [keysDraggedEnterItem, setKeysDraggedEnterItem] = useState("");
    const [isDragStarted, setIsDragStarted] = useState(false);
    const [isElementReoderUsingKeyboard, setIsElementReoderUsingKeyboard] = useState(false);
    const changePosition = (source, dest, insertBefore, emptyNodeIdentifier, persistInMain) => {
        dispatch(placeReqToNewPosition({
            source,
            dest,
            insertBefore,
            emptyNodeIdentifier,
            persistInMain,
        }));
        setDraggedItem("");
        setDraggedEnterItem("");
        setKeysDraggedEnterItem("");
        setIsDragStarted(false);
        setCategory("");
    };
    const changePositionViaKeyboard = (source, keyCode, persistInMain) => __awaiter(this, void 0, void 0, function* () {
        if (!blockMovement) {
            yield Promise.all([
                dispatch(setBlockMovement({ val: true })),
                dispatch(placeReqToNewPositionKeyboard({
                    source,
                    keyCode,
                    persistInMain,
                    movedToPosition,
                })),
            ]);
            setDraggedItem("");
            if (persistInMain) {
                setDraggedEnterItem("");
                setKeysDraggedEnterItem("");
            }
        }
    });
    const firstUpdate = useRef(true);
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        dispatch(setCacheTimelineData({ timelineData }));
        let selectedApplications = [];
        if (timelineData.sections) {
            let { sections } = timelineData;
            let updatedSections = [];
            for (let sec of sections) {
                let { uuid, requirements } = sec;
                let updatedReqs = requirements.map((req) => {
                    if (req.applicationUuid) {
                        selectedApplications.push(req.applicationUuid);
                    }
                    return {
                        uuid: req.uuid,
                        sortOrder: req.sortOrder,
                        sectionUuid: req.sectionUuid,
                        subSectionUuid: req.subSectionUuid,
                    };
                });
                let updatedSubsections = [];
                for (let subSec of sec.subSections) {
                    let { requirements } = subSec;
                    let updatedReqsSub = requirements.map((req) => {
                        if (req.applicationUuid) {
                            selectedApplications.push(req.applicationUuid);
                        }
                        return {
                            uuid: req.uuid,
                            sortOrder: req.sortOrder,
                            sectionUuid: null,
                            subSectionUuid: req.subSectionUuid,
                        };
                    });
                    updatedSubsections.push({
                        uuid: subSec.uuid,
                        requirements: updatedReqsSub,
                    });
                }
                updatedSections.push({
                    uuid,
                    requirements: updatedReqs,
                    subSections: updatedSubsections,
                });
            }
            let requestBody = { uuid: timelineData.uuid, sections: updatedSections };
            let identifier = setTimeout(() => {
                dispatch(updateRequirementsBulk({
                    timelineUuid: timelineData.uuid,
                    requestBody: requestBody,
                }));
            }, 500);
            setSelectedApplications(selectedApplications);
            return () => {
                clearTimeout(identifier);
            };
        }
    }, [timelineData]);
    useEffect(() => {
        let element = document.getElementById("drag-icon-" + keysDraggedEnterItem);
        if (element) {
            element.scrollIntoView();
            element.focus();
        }
    }, [cacheTimelineData]);
    const dismissDrag = (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigateToElement(draggedItem);
        setDraggedItem("");
        setDraggedEnterItem("");
        hideGhostElement();
    };
    const hideGhostElement = () => {
        let ghostElement = document.getElementById("ghost-element-container");
        if (ghostElement !== null) {
            ghostElement.style.display = "none";
        }
    };
    const keyDownHandler = (event, requirement) => {
        var _a;
        const keyCode = event.keyCode ? event.keyCode : event.which;
        if (!(keyCode === 9 && !isElementReoderUsingKeyboard)) {
            event.preventDefault();
        }
        if (keyCode === 13) {
            // enter click
            if (isElementReoderUsingKeyboard) {
                // commit Changes
                setIsElementReoderUsingKeyboard(false);
                setKeysDraggedEnterItem("");
                dispatch(commitCacheTimelineData({}));
                setLiveAriaObject({ requirement, keyCode });
            }
            else {
                setIsElementReoderUsingKeyboard(true);
                setEnableLiveRegion(true);
                setKeysDraggedEnterItem(requirement.uuid);
                setLiveAriaObject({ requirement, keyCode });
            }
            setTimeout(() => {
                var _a;
                (_a = document.getElementById("drag-icon-" + requirement.uuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
        else if (keyCode === 40 || keyCode === 38) {
            // down key
            setLiveAriaObject({ requirement, keyCode });
            changePositionViaKeyboard(keysDraggedEnterItem, keyCode, false);
        }
        else if (keyCode === 9) {
            // Tab key
            if (isElementReoderUsingKeyboard) {
                (_a = document.getElementById("drag-icon-" + requirement.uuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                return;
            }
        }
        else if (keyCode === 27) {
            // Esc key
            setLiveAriaObject({ requirement, keyCode });
            setIsElementReoderUsingKeyboard(false);
            setKeysDraggedEnterItem("");
            dispatch(commitCacheTimelineData({ reset: true }));
            setTimeout(() => {
                var _a;
                (_a = document.getElementById("drag-icon-" + requirement.uuid)) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    };
    const renderRequirement = (req, section, subSection, isSection, index) => {
        var _a, _b;
        let sectionOf = "";
        let additionalClass = "";
        if (isSection) {
            sectionOf = "sections";
            additionalClass = "not-subsection";
        }
        else {
            sectionOf = "sub-sections";
        }
        let ariaLabelText = `${moveText} ${requirementText} ${req.title} of type ${req.requirementType}`;
        let numberOfElements = isSection
            ? section.requirements.filter((elem) => elem.uuid !== draggedItem).length
            : subSection === null || subSection === void 0 ? void 0 : subSection.requirements.filter((elem) => elem.uuid !== draggedItem).length;
        const editApplication = (event, req) => {
            event.preventDefault();
            const step2 = () => {
                setSelectApplication(true);
                setEditMode(true);
                setCurrentRequirement(req);
                showDetailView(false);
                setRequirementId(req.uuid);
                setSectionType(req.sectionUuid ? "sections" : "sub-sections");
                setFocusId(req.uuid);
            };
            dispatch(getApplication({ applicationUuid: req.applicationUuid })).then(() => {
                step2();
            });
        };
        return (_jsx(DraggableItem, Object.assign({ object: { uuid: req.uuid, title: req.title }, draggedItem: draggedItem, setDraggedItem: setDraggedItem, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, index: index, isDragStarted: isDragStarted, setIsDragStarted: setIsDragStarted, categoryType: "requirement", setCategory: setCategory, category: category, isElementReoderUsingKeyboard: isElementReoderUsingKeyboard, keysDraggedEnterItem: keysDraggedEnterItem, numberOfElements: numberOfElements, maxElementsAllowed: Constants.maxRequirementsAllowed }, { children: _jsx("div", Object.assign({ className: `drag-zone flex-row -justified ${additionalClass}` }, { children: _jsxs("div", Object.assign({ className: "requirement-contnr flex-row -justified" }, { children: [_jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsx("div", Object.assign({ id: `drag-icon-${req.uuid}`, className: "drag-svg", tabIndex: 0, role: "button", "aria-label": ariaLabelText, onKeyDown: (event) => keyDownHandler(event, req) }, { children: _jsxs("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("title", { children: "Drag & Drop" }), _jsx("g", Object.assign({ id: "UX:-Drag-&amp;-Drop_" + req.uuid, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", Object.assign({ id: "Section---Drag-&amp;-Drop-State_" + req.uuid, transform: "translate(-366.000000, -446.000000)" }, { children: _jsxs("g", Object.assign({ id: "Drag-&amp;-Drop-Icon_" + req.uuid, transform: "translate(366.000000, 446.000000)" }, { children: [_jsx("polygon", { id: "Path_" + req.uuid, points: "0 0 24 0 24 24 0 24" }), _jsx("path", { d: "M11,18 C11,19.1 10.1,20 9,20 C7.9,20 7,19.1 7,18 C7,16.9 7.9,16 9,16 C10.1,16 11,16.9 11,18 Z M9,10 C7.9,10 7,10.9 7,12 C7,13.1 7.9,14 9,14 C10.1,14 11,13.1 11,12 C11,10.9 10.1,10 9,10 Z M9,4 C7.9,4 7,4.9 7,6 C7,7.1 7.9,8 9,8 C10.1,8 11,7.1 11,6 C11,4.9 10.1,4 9,4 Z M15,8 C16.1,8 17,7.1 17,6 C17,4.9 16.1,4 15,4 C13.9,4 13,4.9 13,6 C13,7.1 13.9,8 15,8 Z M15,10 C13.9,10 13,10.9 13,12 C13,13.1 13.9,14 15,14 C16.1,14 17,13.1 17,12 C17,10.9 16.1,10 15,10 Z M15,16 C13.9,16 13,16.9 13,18 C13,19.1 13.9,20 15,20 C16.1,20 17,19.1 17,18 C17,16.9 16.1,16 15,16 Z", id: "Shape_" + req.uuid, fill: "#6B6B6B", fillRule: "nonzero" })] })) })) }))] })) })), _jsxs("div", Object.assign({ className: "requirement-details " }, { children: [_jsx("div", Object.assign({ className: "requirement-header" }, { children: _jsx("div", Object.assign({ className: "requirement-title " }, { children: req.title })) })), ((_a = req.description) === null || _a === void 0 ? void 0 : _a.trim().length) > 0 && (_jsx("div", Object.assign({ className: "requirement-description" }, { children: (_b = req.description) === null || _b === void 0 ? void 0 : _b.trim() }))), req.requirementType !== "APPLICATION" && (_jsx(WmButton, Object.assign({ icon: "f208", buttonType: "textonly", id: `view-detail-${req.uuid}`, onClick: (event) => renderDetailView(event, req), placeholder: undefined }, { children: translate("app.viewTimeline.view.requirement.details") })))] }), `requirement-${req.uuid}`)] })), _jsx("div", Object.assign({ className: "button-collection" }, { children: _jsxs(WmActionMenu, Object.assign({ "action-menu-type": "icon", id: `requirement-options-${req.uuid}`, tooltip: "Options", placeholder: undefined }, { children: [(req.requirementType == "REQUIREMENT" ||
                                        req.requirementType == "TIME_LOG") && (_jsx(WmMenuitem, Object.assign({ icon: "f3eb", "label-for-identical-buttons": `Edit${req.title}`, id: `edit-requirement-${req.uuid}`, onClick: (event) => editClickHandler(event, req, `edit-requirement-${req.uuid}`, sectionOf), placeholder: undefined }, { children: translate("app.viewTimeline.edit.requirement") }))), req.requirementType == "APPLICATION" && (_jsx(WmMenuitem, Object.assign({ icon: "f3eb", "label-for-identical-buttons": `Edit ${req.title}`, id: `edit-requirement-${req.uuid}`, onClick: (event) => editApplication(event, req), placeholder: undefined }, { children: translate("app.viewTimeline.edit.requirement.application") }))), req.anyFileSubmitted ||
                                        req.reviewed ||
                                        req.acknowledgementSelected ||
                                        req.studentFileUploaded ||
                                        (req.anySubmissionExist &&
                                            req.requirementType !== "TIME_LOG" &&
                                            req.requirementType !== "APPLICATION") ? ("") : (_jsx(WmMenuitem, Object.assign({ icon: "f1c0", "label-for-identical-buttons": `Delete ${req.title}`, id: `delete-requirement-${req.uuid}`, onClick: (event) => openDeleteModal(event, req.title, timelineData.uuid, section.uuid, subSection ? subSection.uuid : "", req.uuid, req.requirementType), placeholder: undefined }, { children: translate("app.viewTimeline.delete.requirement") })))] })) }))] })) })) }), req.uuid));
    };
    const renderSection = (section, index) => {
        let numberOfElements = section.requirements.filter((elem) => elem.uuid !== draggedItem).length;
        return (_jsxs("div", Object.assign({ className: "paper-card drag-card section-card card-width timeline-section" }, { children: [_jsx(DropZone, Object.assign({ nodeId: section.uuid, nodeIdentifier: "section", elements: numberOfElements, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, isDragStarted: isDragStarted, category: category, maxElementsAllowed: Constants.maxRequirementsAllowed }, { children: _jsx("div", Object.assign({ className: "header section-header title-conatiner flex-row -justified -verticallycentered" }, { children: _jsx("h2", Object.assign({ className: "title title-tab" }, { children: section.title })) })) })), _jsxs("div", Object.assign({ className: "body " }, { children: [_jsx("div", Object.assign({ className: "immersive-body" }, { children: section.requirements.map((req, index) => {
                                var _a, _b;
                                if (!((_b = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.sllUser) === null || _a === void 0 ? void 0 : _a.available_apps) === null || _b === void 0 ? void 0 : _b.includes("applications")) &&
                                    req.requirementType === "APPLICATION") {
                                    return _jsx(_Fragment, {});
                                }
                                else {
                                    return renderRequirement(req, section, null, true, index);
                                }
                            }) })), section.requirements.length < 30 ? (_jsx("div", Object.assign({ className: "add-btns" }, { children: _jsx(WmButton, Object.assign({ buttonType: "secondary", icon: "F419", id: "add-requirement-button-" + section.uuid, onClick: (event) => {
                                    event.preventDefault();
                                    setRequirementType("stdReq");
                                    setRequirementTypeOrder({
                                        reqId: "add-requirement-button-" + section.uuid,
                                        sectionType: "sections",
                                        sortOrder: section.requirements.length + 1,
                                    });
                                    setSelectRequirementType(true);
                                    setFocusId("add-requirement-button-" + section.uuid);
                                }, placeholder: undefined }, { children: translate("app.viewTimeline.add.requirement") })) }))) : (""), _jsx("div", Object.assign({ className: "sub-section-list" }, { children: section.subSections.length > 0
                                ? section.subSections.map((subSection) => {
                                    let numberOfElements = subSection === null || subSection === void 0 ? void 0 : subSection.requirements.filter((elem) => elem.uuid !== draggedItem).length;
                                    return (_jsxs("div", Object.assign({ className: "sub-section " }, { children: [_jsx(DropZone, Object.assign({ nodeId: subSection.uuid, nodeIdentifier: "sub-section", elements: numberOfElements, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, isDragStarted: isDragStarted, category: category, maxElementsAllowed: Constants.maxRequirementsAllowed }, { children: _jsx("h3", Object.assign({ className: "-textonly accordion-label title-tab" }, { children: subSection.title })) })), _jsxs("div", Object.assign({ className: "sub-section-body" }, { children: [_jsx("div", Object.assign({ className: "immersive-body" }, { children: subSection.requirements.map((req, index) => {
                                                            var _a, _b;
                                                            if (!((_b = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.sllUser) === null || _a === void 0 ? void 0 : _a.available_apps) === null || _b === void 0 ? void 0 : _b.includes("applications")) &&
                                                                req.requirementType === "APPLICATION") {
                                                                return _jsx(_Fragment, {});
                                                            }
                                                            else {
                                                                return renderRequirement(req, section, subSection, false, index);
                                                            }
                                                        }) })), subSection.requirements.length < 30 ? (_jsx("div", Object.assign({ className: "sub-add-btns" }, { children: _jsx(WmButton, Object.assign({ buttonType: "secondary", icon: "F419", id: "add-requirement-button-" + subSection.uuid, onClick: (event) => {
                                                                event.preventDefault();
                                                                setRequirementType("stdReq");
                                                                setRequirementTypeOrder({
                                                                    reqId: "add-requirement-button-" + subSection.uuid,
                                                                    sectionType: "sub-sections",
                                                                    sortOrder: subSection.requirements.length + 1,
                                                                });
                                                                setSelectRequirementType(true);
                                                                setFocusId("add-requirement-button-" + subSection.uuid);
                                                            }, placeholder: undefined }, { children: translate("app.viewTimeline.add.requirement") })) }))) : ("")] }))] }), "subSection" + subSection.uuid));
                                })
                                : null }))] }))] }), "section" + section.uuid));
    };
    const [planTitleInvalid, setPlanTitleInvalid] = useState(false);
    const [planTitleDuplicate, setPlanTitleDuplicate] = useState(false);
    const [enteredPlanTitle, setEnteredPlanTitle] = useState(timelineData.title);
    const inputRef = useRef();
    const updateTitleHandler = (event) => {
        event.preventDefault();
        setEnteredPlanTitle(event.target.value);
        if (specialCharPattern.test(event.target.value)) {
            setTitleSpecialCharError(true);
        }
        else {
            setTitleSpecialCharError(false);
        }
        setPlanTitleInvalid(false);
        setPlanTitleDuplicate(false);
    };
    const closeEditTitleModal = () => {
        setOpenEditTitleModal(false);
        setPlanTitleInvalid(false);
        setTitleSpecialCharError(false);
        focusButtonComponent("edit-timeline-title");
    };
    const updatePlanTitle = () => __awaiter(this, void 0, void 0, function* () {
        if (enteredPlanTitle.trim() === "") {
            setPlanTitleInvalid(true);
            setPlanTitleDuplicate(false);
            setTitleSpecialCharError(false);
        }
        else {
            yield Promise.all([
                dispatch(validateTimelineTitle({
                    timelineUuid: timelineData.uuid,
                    title: enteredPlanTitle,
                })),
            ]);
            setIsTitleValid(false);
            setTitleSpecialCharError(false);
        }
    });
    useEffect(() => {
        if (!isTitleValid) {
            if (timelineTitleValid) {
                setPlanTitleInvalid(false);
                setPlanTitleDuplicate(false);
                if (enteredPlanTitle !== timelineData.title) {
                    // save title
                    setOpenEditTitleModal(false);
                    dispatch(updateTimeline({
                        timelineUuid: timelineData.uuid,
                        title: enteredPlanTitle,
                    }));
                }
                setOpenEditTitleModal(false);
                focusButtonComponent("edit-timeline-title");
            }
            else {
                setPlanTitleInvalid(true);
                setPlanTitleDuplicate(true);
            }
            setIsTitleValid(true);
        }
    }, [isTitleValid]);
    useEffect(() => {
        if (!selectRequirementType && focusId !== "") {
            focusButtonComponent(focusId);
        }
    }, [selectRequirementType]);
    const infoText = useIntl().formatMessage({
        id: "app.viewTimeline.modal.infoText",
    });
    const modalHeading = useIntl().formatMessage({
        id: "app.viewTimeline.modal.modalHeading",
    });
    const modalSubHeading = useIntl().formatMessage({
        id: "app.viewTimeline.modal.modalSubHeading",
    });
    const modalLable = useIntl().formatMessage({
        id: "app.viewTimeline.modal.lable.title",
    });
    const flyoutCreateTitle = useIntl().formatMessage({
        id: "app.viewTimeline.flyout.title.create.timeline",
    });
    const flyoutEditTitle = useIntl().formatMessage({
        id: "app.viewTimeline.flyout.title.edit.timeline",
    });
    const emptyErrorText = useIntl().formatMessage({
        id: "app.viewTimeline.modal.emptyErrorText",
    });
    const duplicateErrorText = useIntl().formatMessage({
        id: "app.viewTimeline.modal.duplicateErrorText",
    });
    const renderEditTitleModal = (isOpen) => {
        if (!isOpen) {
            return "";
        }
        let modalTitle = enteredPlanTitle;
        let modalFor = "plan-title";
        let customError = "";
        if (planTitleInvalid) {
            if (planTitleDuplicate) {
                customError = duplicateErrorText;
            }
            else {
                customError = emptyErrorText;
            }
        }
        return (_jsxs(WmModal, Object.assign({ open: isOpen, elementToFocus: "input-" + modalFor, id: "edit-title-modal", onWmModalCloseTriggered: () => closeEditTitleModal(), onWmModalPrimaryTriggered: (event) => {
                event.preventDefault();
                if (specialCharPattern.test(enteredPlanTitle.trim())) {
                    setTitleSpecialCharError(true);
                    return;
                }
                else if (!titleSpecialCharError) {
                    updatePlanTitle();
                }
            }, onWmModalSecondaryTriggered: () => closeEditTitleModal(), "aria-label": modalHeading, uid: "", placeholder: undefined }, { children: [_jsx(WmModalHeader, { heading: modalHeading, subheading: modalSubHeading, placeholder: undefined }), _jsx("div", Object.assign({ id: "content-edit-title-modal", className: "content" }, { children: _jsxs("div", Object.assign({ className: "modal-body" }, { children: [_jsx(InputField, { titleError: planTitleInvalid || titleSpecialCharError, dataLabel: modalLable, modalTitle: modalTitle, updateTitleHandler: updateTitleHandler, inputRef: inputRef, modalFor: modalFor, modalId: modalFor, required: true, customError: true, customErrorMessage: titleSpecialCharError ? customErrorMessage : customError }), _jsx("span", Object.assign({ className: "info-text" }, { children: infoText }))] })) })), _jsx(WmModalFooter, { primaryText: "Save", secondaryText: "Cancel", placeholder: undefined })] })));
    };
    return isFetchingTimeline ? (_jsx("div", Object.assign({ className: "loader -fullscreen" }, { children: _jsx("div", Object.assign({ className: "content content-loader" }, { children: "Loading..." })) }))) : (_jsxs("main", { children: [_jsx("div", { className: "sr-only", id: "dialog-wrapper-top", tabIndex: 0 }), selectRequirementType ? (_jsx(SelectRequirementType, { requirementType: requirementType, setRequirementType: setRequirementType, setSelectRequirementType: setSelectRequirementType, addRequirementHandler: addRequirementHandler, addAppHandler: addAppHandler, addTimeLogHandler: addTimeLogHandler })) : addRequirementPage ? (_jsx(Requirements, { requirementId: requirementId, addRequirement: addRequirementPage, setAddRequirementPage: setAddRequirementPage, timelineUuid: timelineUuid, sectionType: sectionType, currentRequirement: currentRequirement, setSelectRequirementType: setSelectRequirementType })) : addTimeLogPage ? (_jsx(TimeLogRequirements, { requirementId: requirementId, addTimeLogPage: addTimeLogPage, setAddTimeLogPage: setAddTimeLogPage, timelineUuid: timelineUuid, sectionType: sectionType, currentRequirement: currentRequirement, setSelectRequirementType: setSelectRequirementType })) : showEditableTimeline ? (_jsx(EditTimeline, {})) : (_jsx(DraggableArea, Object.assign({ dismissDrag: dismissDrag, category: category }, { children: _jsxs("div", Object.assign({ className: `flyout-container view-timeline  ${isDragStarted ? "dragIsStarted" : ""} ` }, { children: [_jsx("div", Object.assign({ className: "immersive-header  -immersive header" }, { children: _jsxs("div", Object.assign({ className: "page-header flex-row -justified -verticallycentered" }, { children: [_jsxs("div", Object.assign({ className: "flex-row -justified -verticallycentered" }, { children: [_jsx(WmButton, { buttonType: "navigational", className: "cancel hydrated", icon: "f04d", iconSize: "big", customBackground: "dark", onClick: (event) => closeTimelineHandler(event), tooltip: "Go Back", placeholder: undefined }), _jsxs("h1", Object.assign({ className: "flyout-title" }, { children: [location.search == "?create"
                                                        ? "Create Licensure Plan"
                                                        : location.search === "?copy"
                                                            ? "Copy Licensure Plan"
                                                            : "Edit Licensure Plan", ": ", currentProgramData.title, _jsx("div", Object.assign({ className: "title-desc" }, { children: location.search === "?create" || "?edit"
                                                            ? flyoutCreateTitle
                                                            : flyoutEditTitle }))] }))] })), _jsxs("div", Object.assign({ className: "flex-row -justified -verticallycentered" }, { children: [_jsx(WmButton, Object.assign({ buttonType: "secondary", id: "edit-timeline", customBackground: "dark", onClick: (event) => editTimelineHandler(event), placeholder: undefined }, { children: translate("app.editTimeline.edit_outline.label") })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "done-btn", customBackground: "dark", onClick: (event) => closeTimelineHandler(event), placeholder: undefined }, { children: "Done" }))] }))] })) })), _jsxs("section", Object.assign({ className: `${detailView ? "flex-row panels" : ""}` }, { children: [_jsx("div", Object.assign({ className: ` immersive-container flyout-data  ${detailView ? "pagecontent licensure-pagecontent " : ""}` }, { children: _jsxs("div", Object.assign({ className: "licensure-plans-timeline card-width" }, { children: [_jsxs("div", Object.assign({ className: "paper-card section-card card-width plan-title flex-row -justified -verticallycentered" }, { children: [_jsxs("div", { children: [_jsx("p", Object.assign({ className: "plan-title-label" }, { children: translate("app.licensurePlans.planTitle") })), location.search === "?copy" ? (_jsx("p", Object.assign({ className: "timeline-title" }, { children: timelineData.title }))) : (_jsx("p", Object.assign({ className: "timeline-title" }, { children: timelineData.title })))] }), _jsx(WmButton, { buttonType: "icononly", icon: "f3eb", iconSize: "big", tooltip: "Edit Title", id: "edit-timeline-title", tooltipPosition: "bottom", onClick: (event) => editTitleHandler(event, timelineData.title), placeholder: undefined })] }), "timeline-title"), _jsx("div", Object.assign({ className: "timeline-sections", role: "application" }, { children: timelineSections
                                                    ? timelineSections.map((section, index) => {
                                                        return renderSection(section, index);
                                                    })
                                                    : null }))] })) })), _jsx("div", { className: "sr-only", id: "dialog-wrappers-top", tabIndex: 0 }), detailView && (_jsx("div", Object.assign({ className: "mini-panel immersive-container  flyout-data " }, { children: _jsx(ViewDetails, { removeDetailView: removeDetailView, currentRequirement: currentRequirement }) }))), selectApplication && (_jsx(SelectApplication, { requirementId: requirementId, setSelectApplication: setSelectApplication, setSelectRequirementType: setSelectRequirementType, timelineUuid: timelineUuid, sectionType: sectionType, currentRequirement: currentRequirement, selectedApp: editMode ? applicationObj : null, alreadySelectedApps: selectedApplications })), _jsx("div", { className: "sr-only", id: "dialog-wrappers-bottom", tabIndex: 0 })] })), renderDeleteSectionModal(openDeleteRequestModal, currentRequirementType), renderInformationModal(openEditWarningRequestModal), renderEditTitleModal(openEditTitleModal), renderLiveRegion(), _jsx(WmSnackbar, { notifications: snackNotifications, id: "licensure-plans-snack", onWmSnackbarSnackFinished: (event) => finishedSnackHandler(event), placeholder: undefined })] })) }))), _jsx("div", { className: "sr-only", id: "dialog-wrapper-bottom", tabIndex: 0 })] }));
}
